import { render, staticRenderFns } from "./ClinicalGuideManager.vue?vue&type=template&id=537941a1&scoped=true&"
import script from "./ClinicalGuideManager.vue?vue&type=script&lang=js&"
export * from "./ClinicalGuideManager.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalGuideManager.vue?vue&type=style&index=0&id=537941a1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537941a1",
  null
  
)

export default component.exports